import _get from 'lodash/get';
import { EMPTY_ARRAY, EMPTY_STRING } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { ACTION, PAGE_NAMES, RESOURCES } from 'constant';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import { REFUND_STATUSES, REFUND_STATUSES_LABEL, VIEW_FIELD_KEYS } from '../constants';
import { ACTION_IDS, ACTION_LABELS } from './constants';

export const makeActionList = (params?: any) => {
	const { keyConfig, mttid } = params;
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	switch (_get(keyConfig, 'name', EMPTY_STRING)) {
		case VIEW_FIELD_KEYS.REFUNDED:
			return [
				{
					id: ACTION_IDS.REFUND_TOURNAMENT,
					label: ACTION_LABELS[ACTION_IDS.REFUND_TOURNAMENT],
					isEnabled: ({ keyData }: { keyData: any }) =>
						!_isNil(mttid) &&
						!_isEmpty(mttid) &&
						keyData === REFUND_STATUSES_LABEL[REFUND_STATUSES.NOT_REFUNDED] &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.gameplay,
							configActionName: ACTION.refundTournament
						})
				}
			];
		default:
			return EMPTY_ARRAY;
	}
};

export default {
	makeActionList
};
